export enum GroupShareListSideEnum {
  Available = 1,
  Group = 2
}